<template>
  <div>
    <div class="mb-4 p-6 text-white bg-primary rounded" v-if="device.uid">
      <h4 class="text-white mb-2"> {{$t("Warning")}} </h4>
      <div> {{$t("TxtDelete")}} <strong> {{$t("TxtDeleteTwo")}} </strong>.</div>
      <div> {{$t("TxtDeleteThree")}} </div>
    </div>

    <div class="vx-row" v-if="device.uid">
      <div class="vx-col mb-4 w-full lg:w-1/3" v-for="table in tablesMobile" :key="table.id">
        <button
          name="button"
          class="vs-component vs-button vs-button-danger vs-button-relief w-full"
          @click="deleteRecords(device.uid, table.id)"
          :disabled="processing"
        >
          <span class="vs-button-text vs-button--text">
            <i class="fas fa-eraser"></i>
            {{ table.title }}
          </span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
        </button>
      </div>
    </div>

    <div class="flex justify-center" v-if="device.uid">
      <router-link
        to="/dispositivo"
        name="button"
        class="vs-component vs-button vs-button-success vs-button-relief mt-2"
      >
        <span class="vs-button-text vs-button--text">
          <i class="fas fa-arrow-circle-left"></i> {{$t("Return")}}
        </span>
        <span
          class="vs-button-linex"
          style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"
        ></span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      device: {},
      processing: false,
      tablesMobile: [
        {
          id: "messenger:whatsapp",
          title: "WhatsApp Chat",
        },
        {
          id: "messengeraudio",
          title: "WhatsApp Áudio",
        },
        {
          id: "messengercall",
          title: "WhatsApp Chamadas",
        },
        {
          id: "messenger:instagram",
          title: "Instagram",
        },
        {
          id: "messenger:telegram",
          title: "Telegram",
        },
        {
          id: "messenger:tinder",
          title: "Tinder",
        },
        {
          id: "messenger:kwai",
          title: "Kwai",
        },
        {
          id: "messenger:badoo",
          title: "Badoo",
        },
        {
          id: "messenger:snapchat",
          title: "Snapchat",
        },
        {
          id: "call",
          title: "Chamadas",
        },
        {
          id: "keylogger",
          title: "Teclas",
        },
        {
          id: "contact",
          title: "Contatos",
        },
        {
          id: "webhistory",
          title: "Sites",
        },
        {
          id: "websearch",
          title: "Pesquisas",
        },
        {
          id: "sms",
          title: "SMS",
        },
        {
          id: "location",
          title: "Localização",
        },
        {
          id: "photo",
          title: "Foto Remota",
        },
        {
          id: "photogallery",
          title: "Galeria",
        },
        {
          id: "screenshot",
          title: "Screenshot",
        },
        {
          id: "microphone",
          title: "Microfone",
        },
      ],
    };
  },
  mounted() {
    const uid = this.$route.params.uid;
    this.$api
    .get(`/api/v1/mobile/device/${uid}`)
    .then((response) => {
      this.device = response.data.data;
      if (!this.device.licence.active) {
        this.$vs.notify({
          time: 8000,
          title: "Erro",
          text:
            "Somente dispositivos com uma licença ativa podem ter os dados apagados.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });

        this.$router.push("/dispositivo");
      }
    })
    .catch(() => {
      this.$router.push("/dispositivo");
    });
  },
  methods: {
    deleteRecords(uid, table) {
      this.processing = true;
      this.$api
      .delete(`/api/v1/mobile/delete-record/${uid}/${table}`)
      .then(() => {
        this.processing = false;

        this.$vs.notify({
          time: 6000,
          text: "Dados agendados para exclusão.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
      })
      .catch((error) => {
        this.processing = false;

        this.$vs.notify({
          time: 6000,
          title: "Aviso",
          text: error.response.data.error || error.response.data.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      });
    },
  },
};
</script>
